import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(manageAuthHeader);

import { takeEvery } from 'redux-saga/effects';
import { actionTypes } from 'ackee-redux-token-auth';
import * as Store from '../store';
export default function manageAuthHeader() {
  var _Store$get, setAuthHeader, authAxios, headers;

  return _regeneratorRuntime.wrap(function manageAuthHeader$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _Store$get = Store.get(Store.keys.CONFIG), setAuthHeader = _Store$get.setAuthHeader;
          authAxios = Store.get(Store.keys.AUTH_AXIOS);
          headers = authAxios.defaults.headers;
          _context.next = 5;
          return takeEvery(actionTypes.ACCESS_TOKEN_AVAILABLE, function (action) {
            setAuthHeader(headers, action.payload);
            Store.set(Store.keys.IS_AUTH, true);
          });

        case 5:
          _context.next = 7;
          return takeEvery(actionTypes.ACCESS_TOKEN_UNAVAILABLE, function () {
            Store.set(Store.keys.IS_AUTH, false);
            setAuthHeader(headers, null);
          });

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}